// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1UVuX","header":"MergedInvoice_header__1Dq5r"};